import { LoginComponent } from "../app/components/login/login.component";

export const environment = {
  production: false,
  language: "sl",
  wgProfileHost: "https://avtoprevozniki2-api.borzen.si",
  wgPlatformHost: "https://avtoprevozniki2-platform.borzen.si",

  loginComponent: LoginComponent,
  projIcon: "/assets/project-custom/images/logo.png",
  sidebarIcon: "/assets/project-custom/images/logo.png",
  projectCode: "BORZEN_AP",
  projectName: "",
    locale: 'sl-SI',
    projectSidebarName: "",

  useRouteAndMasterpageCache: true,
  ADLoginEnabled: false,
  dateFormat: 'DD.MM.YYYY',
  navigateAwayPopupEnabled: true,
  useEtag: true,
  newRegistrationLinkDocument: "",
  maxChunkNumber: 40,
  maxFileSizeInMb: 5,
  maxRecordNumberPerPageListing: 30,
  cacheEnabled: false,
  version: '1.1.0',
  showOnlyUserInHeader: true,
  googleClientId: "344277045222-9plssap1pl1o4p6bk266t6h2t1rggbik.apps.googleusercontent.com",
  useOldSearchViewFeature: false,
  maxFileSizeInMbInMessenger:10,
  usernameAlwaysToLower: true, // need this shit for EVOZILA1
  useInlineSearch: false
};